import { Modal } from 'ccs-ui-components';
import { useState } from 'react';

interface ConfirmDialogData {
  title: string;
  message: string;
  okText: string;
  cancelText: string;
  testId?: string;
}

const useConfirmDialog = () => {
  const [dialogData, setDialogData] = useState<ConfirmDialogData>();
  const [resolve, setResolve] = useState<(result: boolean) => void>();
  const [showDialog, setShowDialog] = useState(false);

  const closeHandler = () => {
    if (resolve) {
      resolve(false);
    }
    setShowDialog(false);
  };

  const confirmHandler = () => {
    if (resolve) {
      resolve(true);
    }
    setShowDialog(false);
  };

  const show = (data: ConfirmDialogData) => {
    setDialogData(data);
    setShowDialog(true);
    return new Promise<boolean>((resolve) => {
      setResolve(() => resolve);
    });
  };

  const render = () => (
    <Modal
      modalTitle={dialogData?.title}
      modalBody={dialogData?.message}
      modalShow={showDialog}
      btnSaveText={dialogData?.okText}
      btnCloseText={dialogData?.cancelText}
      onCloseModal={closeHandler}
      onSaveModal={confirmHandler}
      alignToCentre
      data-testid={dialogData?.testId}
      disableCloseBtn={false}
      disableSaveBtn={false}
      type="warning"
    />
  );

  return { render, show };
};

export default useConfirmDialog;
